// @ts-nocheck
import { PureComponent } from 'react';
import { Platform } from 'react-native';
import Theme from '@qnpm/q-theme';
import { QToast } from '@qnpm/q-components';
import { commonUtil, dateUtil, logEvent, performanceUtil, QavEvent } from '@qnpm/q-design-utils';
import { generatorWeekHeader } from '../../utils/dateUtil';
import { computeCalendarData, computeCalendarHeight, computeCallbackData, computeDerivedStateData, computedInitScrollPosition, computedMonthKey, computedSelectedSectionIndexes, computeInitState, computeLimitCalendarData, computeSelectedIndexes, validAndAdjustProps, validSelectedLimit } from '../../utils/handle';
import { CALENDAR_TYPE, SELECTED_DATE_NUM } from '../../utils/constant';
import Style from '../style';
const { calendar: calendarLayout } = Theme.layout;
const isIOS = Platform.OS === 'ios';
export default class BaseCalendar extends PureComponent {
    constructor(props, type) {
        super(props);
        this.weekHeaderData = [];
        this.validProps = BaseCalendar.defaultProps;
        this.isIOS = isIOS;
        this.offset = 0;
        // 日历不支持缩放
        this.needScale = false;
        // 首次渲染是否完成
        this.firstRendered = false;
        // 是否手动滚动过
        this.hasScrolled = false;
        // 选中月份下标
        this.selectedMonthIndex = 0;
        this.monthHeight = [];
        /**
         * 更新选中日期
         * @param data
         * @param position
         */
        this.updateState = (data, position) => {
            var _a, _b;
            let nextDate = data;
            let nextPosition = position;
            const { mode = CALENDAR_TYPE.SINGLE, startWith, selectedPayload, getMergeDesc, selectScroll = false, canSelectSameDay, beforeSelect, dataSource = {} } = this.props;
            const { selectedDate: sSelectedDate, calendarData: sCalendarData } = this.state;
            this.printLog({
                action: 'select_date',
                attributes: { date: data.value }
            });
            // 计算限制信息
            const limitInfo = this.checkSelectDateIsLimited(data);
            // 只有返回调整数据时，才需要设置
            if (limitInfo) {
                nextDate = limitInfo.date;
                nextPosition = limitInfo.position;
            }
            // 调用外部函数决定是否要选中
            if (commonUtil.isFunction(beforeSelect)) {
                // 当前模式应该有的选中日期数量
                const modeLen = SELECTED_DATE_NUM[mode];
                // 已选中的数量
                const selectedLen = sSelectedDate.length;
                // 是否选了比已选日期小的日期
                const isSelectLowDate = sSelectedDate.every((item) => dateUtil.compareDateWithDay(nextDate.value, item.value));
                // 设置选中下标
                const nextIndex = selectedLen >= modeLen || isSelectLowDate ? 0 : selectedLen;
                const validData = computeCallbackData(nextDate, dataSource, nextIndex);
                // 设置头部信息
                validData.header = (_b = (_a = selectedPayload[nextIndex]) === null || _a === void 0 ? void 0 : _a.header) === null || _b === void 0 ? void 0 : _b.text;
                // 执行回调决定是否需要选中
                if (!beforeSelect(validData)) {
                    this.printLog({
                        action: 'terminate_select_date_by_outer_action'
                    });
                    return;
                }
            }
            // 计算新的日历
            const { calendarData, needCallback, selectedDate, sameDayResult, selectedIndex } = computeCalendarData({
                calendarData: sCalendarData,
                data: nextDate,
                selectedDate: sSelectedDate,
                mode,
                startWith,
                position: nextPosition,
                selectedPayload,
                getMergeDesc,
                canSelectSameDay
            });
            const isFirst = selectedIndex === 0;
            this.setState({
                calendarData,
                selectedDate,
                showToolTipMonth: computedMonthKey(nextDate.year, nextDate.month),
                selectedSameDay: sameDayResult
            }, () => {
                // 选中后自动滚动到该日期
                isFirst &&
                    selectScroll &&
                    this.autoScroll(calendarData, nextPosition.blockID, nextDate);
                this.onCallback(nextDate, selectedDate, needCallback, selectedIndex);
            });
            // 通知子组件日期数据变化
            this.notifyCalendarDataChanged(calendarData);
            isFirst &&
                commonUtil.isValidArray(sSelectedDate) &&
                this.printLog({
                    action: 'reset_select_date',
                    attributes: {
                        oldDate: sSelectedDate.map((item) => item.value).toString(),
                        newDate: selectedDate.map((item) => item.value).toString()
                    }
                });
        };
        /**
         * 获取滚动句柄
         */
        this.getScrollResponder = () => {
            // ref存在时，获取scrollView引用
            if (this.scrollRef) {
                // this.scrollRef为ScrollView时，直接返回
                if (this.scrollRef.getScrollResponder) {
                    return this.scrollRef.getScrollResponder();
                }
                // 如果不是，则检查是否是基于ScrollView封装的列表（如：FlatList，SectionList），是的话返回scrollView
                return (this.scrollRef._listRef &&
                    this.scrollRef._listRef.getScrollResponder &&
                    this.scrollRef._listRef.getScrollResponder());
            }
            return undefined;
        };
        /**
         * 滚动到指定位置
         * @param x
         * @param y
         * @param animated
         */
        this.scrollToPosition = (x, y, animated = true) => {
            const responder = this.getScrollResponder();
            responder &&
                responder.scrollResponderScrollTo &&
                responder.scrollResponderScrollTo({ x, y, animated });
        };
        /**
         * 设置滚动标识
         */
        this.onScroll = (event) => {
            const { onScroll } = this.props;
            if (!this.hasScrolled) {
                this.hasScrolled = true;
            }
            commonUtil.isFunction(onScroll) && onScroll(event);
        };
        /**
         * 获取滚动列表ref
         * @param ref
         */
        this.getScrollRef = (ref) => {
            const { getScrollRef } = this.props;
            commonUtil.isFunction(getScrollRef) && getScrollRef(ref);
        };
        /**
         * 加载完成后校验是否有默认选中日期被限制
         */
        this.showLimitMessage = () => {
            if (!this.firstRendered) {
                this.firstRendered = true;
                setTimeout(() => this.checkInitDateLimit(), 30);
            }
        };
        const { locale, startWeek = 0, selectScrollPosition } = props;
        const isNative = type === 'native';
        this.calendarType = type;
        this.isFlat = type === 'flat';
        // 校验及调整后的参数
        this.validProps = validAndAdjustProps(props);
        this.state = computeInitState(this.validProps);
        this.scrollRef = null;
        this.weekHeaderData = generatorWeekHeader(locale, startWeek);
        this.computedStyle = new Style(this.needScale);
        this.scrollPosition = selectScrollPosition;
        this.calendarLayout = this.needScale
            ? calendarLayout.scaled
            : calendarLayout.unscaled;
        const { height, monthHeights } = computeCalendarHeight(this.state.calendarData, this.calendarLayout, this.isFlat, this.scrollPosition, !isNative);
        // 计算日历高度
        this.calendarHeight = height;
        // 计算每个月份的高度
        this.monthHeight = monthHeights;
        // 执行初始回调
        this.initCallback();
        // 非native日历时，自动调用compute方法计算选中位置；native日历中会自己调用
        !isNative && this.computedSelectedPosition();
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        return computeDerivedStateData(nextProps, prevState);
    }
    componentDidMount() {
        this.printLog({ action: 'show' });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    componentDidUpdate(prevProps) {
        const { dataSource, onDataSourceRendered } = this.props;
        // 数据发生变化时进行回调
        if (!performanceUtil.shallowEqual(dataSource, prevProps === null || prevProps === void 0 ? void 0 : prevProps.dataSource)) {
            const { selectedDate } = this.state;
            // 计算默认选中日期信息
            const dispatchDate = commonUtil.isValidArray(selectedDate)
                ? this.computeDispatchDate(selectedDate)
                : [];
            // 回调时返回当前选中日期信息
            commonUtil.isFunction(onDataSourceRendered) &&
                onDataSourceRendered(dispatchDate);
        }
    }
    componentWillUnmount() {
        this.monthHeight = [];
        this.firstRendered = false;
        this.hasScrolled = false;
        this.printLog({ action: 'hide' });
    }
    /**
     * 打印日志
     * @param data
     * @protected
     */
    printLog(data) {
        const { mode, accessibilityPreName } = this.props;
        logEvent(new QavEvent(Object.assign(Object.assign({ page: accessibilityPreName, model: 'base_calendar' }, data), { attributes: Object.assign({ mode, operTime: Date.now() }, data.attributes) })));
    }
    /**
     * 默认选中的回调
     */
    initCallback() {
        const { selectedDate } = this.state;
        commonUtil.isValidArray(selectedDate) &&
            this.onFinishCallBack(selectedDate, true);
    }
    /**
     * 执行回调，回传诗句
     * @param data
     * @param selectedDate
     * 有回调函数且非完成后回调或需要完成后回调且已完成选择
     * @param needCallback
     * @param selectedIndex
     */
    onCallback(data, selectedDate, needCallback, selectedIndex) {
        const { finishCallback, onSelect, dataSource = {} } = this.props;
        // 不需要完成后回调时，每次选择都回调
        if (onSelect && !finishCallback) {
            const dispatchDate = computeCallbackData(data, dataSource, selectedIndex);
            onSelect(dispatchDate);
            return;
        }
        // 需要完成后回调，且已完成选择
        if (onSelect && finishCallback && needCallback) {
            this.onFinishCallBack(selectedDate);
        }
    }
    /**
     * 回调
     * @param selectedDate
     * @param isInit
     */
    onFinishCallBack(selectedDate, isInit = false) {
        const { onSelect, onInitCallback } = this.props;
        const { calendarData } = this.state;
        const dispatchDate = this.computeDispatchDate(selectedDate);
        if (isInit) {
            onInitCallback && onInitCallback(dispatchDate, calendarData);
        }
        else {
            onSelect && onSelect(dispatchDate);
        }
    }
    /**
     * 计算返回数据
     * @param selectedDate
     * @protected
     */
    computeDispatchDate(selectedDate) {
        const { mode, dataSource = {} } = this.props;
        const callBackDate = computeCallbackData(selectedDate, dataSource);
        return mode === CALENDAR_TYPE.SINGLE ? callBackDate[0] : callBackDate;
    }
    /**
     * 点击后自动滚动到选中日期
     * @param calendarData
     * @param sectionID
     * @param data
     */
    autoScroll(calendarData, sectionID, data) {
        const positionIndexes = computeSelectedIndexes(calendarData, sectionID, data);
        const offset = computedInitScrollPosition(positionIndexes, this.calendarLayout, false, this.scrollPosition);
        this.scrollToPosition(0, offset);
    }
    /**
     * 计算初始滚动位置
     */
    computedSelectedPosition(isInit = true) {
        const { calendarData, selectedDate } = this.state;
        const { selectedDate: pSelectedDate } = this.validProps;
        const result = computedSelectedSectionIndexes(calendarData, isInit ? pSelectedDate : selectedDate.map((item) => item === null || item === void 0 ? void 0 : item.value));
        // 是否是一个非空对象
        const isValid = commonUtil.isValidObject(result);
        // 只有存在时，才计算
        if (isValid) {
            this.offset = computedInitScrollPosition(result, this.calendarLayout, false, this.scrollPosition);
            // 只有初始状态时才需要设置位置
            if (isInit) {
                // 设置当前选中月份的下标
                this.selectedMonthIndex = Math.max(...Object.keys(result));
            }
            return {
                offset: this.offset,
                position: result
            };
        }
        return {
            offset: 0,
            position: result
        };
    }
    /**
     * 通知子组件calendarData发生了变化
     * @private
     */
    notifyCalendarDataChanged(calendarData) {
        this.onCalendarDataChanged && this.onCalendarDataChanged(calendarData);
    }
    /**
     * 检验限制信息
     * @param data
     * @param isInit
     * @private
     */
    checkSelectDateIsLimited(data, isInit = false) {
        const { limitInfo, mode = CALENDAR_TYPE.SINGLE } = this.props;
        const { selectedDate, calendarData } = this.state;
        // 校验限制信息 - 是范围选择&有限制配置&正在选择第二个时 --- 如果是默认校验的话，忽略选中长度
        if (commonUtil.isValidObject(limitInfo) &&
            mode === CALENDAR_TYPE.RANGE &&
            (selectedDate.length === 1 || isInit)) {
            const validInfo = validSelectedLimit(calendarData, limitInfo, selectedDate[0], data);
            // 只有返回了校正数据时，才修改选中数据且弹出提示
            if (commonUtil.isValidObject(validInfo)) {
                QToast.show(validInfo.message);
                this.printLog({
                    action: 'show_select_limit_message',
                    attributes: { message: validInfo.message }
                });
                return { date: validInfo.date, position: validInfo.position };
            }
        }
        return null;
    }
    /**
     * 默认校验限制信息
     * @private
     */
    checkInitDateLimit() {
        const { selectedPayload, mode = CALENDAR_TYPE.SINGLE } = this.props;
        const { selectedDate, calendarData } = this.state;
        // 只有范围选择才校验；如果没有默认选中日期或者默认选中提起不足两个，则不校验
        if (mode !== CALENDAR_TYPE.RANGE ||
            !commonUtil.isValidArray(selectedDate) ||
            selectedDate.length < 2) {
            return null;
        }
        // 计算校正信息
        const limitData = this.checkSelectDateIsLimited(selectedDate[1], true);
        // 如果存在校正信息，则使用校正信息重新选择
        if (limitData) {
            const newCalendarData = computeLimitCalendarData(calendarData, limitData.position, selectedDate[1], selectedPayload[1]);
            const newSelectedData = [...selectedDate];
            newSelectedData[1] = Object.assign(Object.assign(Object.assign({}, newSelectedData[1]), limitData.date), { ids: limitData.position });
            // 更新日历状态
            this.setState({
                calendarData: newCalendarData,
                selectedDate: newSelectedData
            }, () => this.initCallback());
            // 通知子组件日期数据变化
            this.notifyCalendarDataChanged(newCalendarData);
        }
    }
}
BaseCalendar.defaultProps = {
    minDate: new Date(),
    maxDate: dateUtil.appendDate(new Date(), { date: 363 }, { format: true }),
    startWeek: 0,
    blankOut: true,
    showUnderMonth: false,
    locale: 1,
    onSelect: () => { },
    initialNumToRender: 2,
    dayScale: 0.95,
    startWith: undefined,
    canSelectSameDay: true,
    mode: 'single',
    monthHeaderConfig: {},
    selectScrollPosition: 'month',
    serviceTime: new Date(),
    limitInfo: {},
    accessibilityPreName: 'q_design_calendar',
    extraDayContent: ['今天'],
    initScrollDuration: isIOS ? 60 : 120,
    stickyHeader: true,
    get startTime() {
        return this.minDate;
    },
    get endTime() {
        return this.maxDate;
    },
    allowDates: [],
    denyDates: []
};
